module.exports = __webpack_public_path__ + "static/media/wpl3.png.4445376a.jpg";